import React, { useState } from 'react';
import PropTypes from 'prop-types';

const DELAY = 250;
const NUMBER_OF_CARDS = 3;

function RoleSelectorMobile({children, onComplete}) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const setNextCard = () => {
        setTimeout(() => {
            if (NUMBER_OF_CARDS <= currentIndex + 1) {
                return onComplete();
            }
        
            setCurrentIndex(index => index + 1);
        }, DELAY);
    };

    return children(currentIndex, setNextCard);
};

RoleSelectorMobile.propTypes = {
    children: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
};

export {
    RoleSelectorMobile
};
